import React, { Component } from "react"
import { SelectWithSearch, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModal } from "../modais"
export default class RelatorioFiscaisForm extends Component {
  constructor() {
    super()
    this.getFiscais = this.getFiscais.bind(this)
    this.onChangeFiscal = this.onChangeFiscal.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      fiscais: [],
      showLoad: false,
      fiscal: ""
    }
  }
  componentWillMount() {
    this.getFiscais()
  }
  onChangeFiscal(event) {
    this.setState({
      fiscal: event,
      formError: ""
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Fiscais",
      fiscal_id:
        this.state.fiscal === undefined || this.state.fiscal === null
          ? null
          : this.state.fiscal.value
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Relatório de fiscais.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        console.log("Error")
      }
    })
  }
  getFiscais() {
    ApiHelper.getFiscais((fiscais, error) => {
      if (fiscais) {
        var mapped = Util.mapGestores(fiscais)
        mapped.shift()
        this.setState({
          fiscais: mapped
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="row" style={{ marginTop: 100 }}>
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="card card-content">
        <div className="row">
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <SelectWithSearch
            error={this.state.formError}
            sizeClass="col-md-8"
            options={this.state.fiscais}
            label="Fiscal"
            placeholder="Selecione um fiscal ou deixe em branco para selecionar todos"
            onChange={this.onChangeFiscal}
            value={this.state.fiscal}
          />
        </div>
        <div className="row">
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-left"
            data-background-color="as-blue"
          >
            Gerar
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/RelatorioFiscaisForm.js